// Smooth open and close for .product-info-panel drop-downs (Product Manual Drop Down block).
// Browsers with ::details-content and interpolate-size animate in CSS (assets/main.build.css).
// This script covers the other browsers. The native <details> keeps working without it.
(function () {
  if (window.__productInfoPanels) return;
  window.__productInfoPanels = true;

  // Runs on both paths. The first click or key press on a summary lets the icon animate,
  // so open-by-default panels and re-rendered panels do not animate on load.
  function touch(event) {
    var summary = event.target.closest && event.target.closest('.product-info-panel__summary');
    if (!summary || !summary.parentNode) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    document.documentElement.setAttribute('data-pip-ready', '');
    summary.parentNode.setAttribute('data-pip-touched', '');
  }
  document.addEventListener('click', touch, true);
  document.addEventListener('keydown', touch, true);

  // Spec table divider animation (runs on both paths). A user click on a summary starts it when the
  // panel opens and stops it when the panel closes, so a re-open plays it again. A panel that is open
  // on page load, or re-rendered by a variant change, never gets data-divider-play, so it stays still.
  // Rows get data-divider-in when they enter view; each batch is staggered by --divider-stagger ms.
  var motionOk = window.matchMedia('(prefers-reduced-motion: no-preference)');

  function stopDivider(details) {
    details.removeAttribute('data-divider-play');
    if (details.__pipObserver) {
      details.__pipObserver.disconnect();
      details.__pipObserver = null;
    }
    var rows = details.querySelectorAll('[data-divider-row]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].removeAttribute('data-divider-in');
      rows[i].style.removeProperty('--pip-delay');
    }
  }

  function reveal(rows) {
    for (var i = 0; i < rows.length; i++) {
      var step = parseFloat(window.getComputedStyle(rows[i]).getPropertyValue('--divider-stagger')) || 0;
      rows[i].style.setProperty('--pip-delay', i * step + 'ms');
      rows[i].setAttribute('data-divider-in', '');
    }
  }

  function startDivider(details) {
    var rows = details.querySelectorAll('[data-divider-row]');
    if (!rows.length || !motionOk.matches) return;
    if (details.__pipObserver) details.__pipObserver.disconnect();
    details.setAttribute('data-divider-play', '');
    if (!('IntersectionObserver' in window)) {
      reveal(rows);
      return;
    }
    details.__pipObserver = new IntersectionObserver(function (entries, observer) {
      var seen = [];
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          seen.push(entry.target);
          observer.unobserve(entry.target);
        }
      });
      reveal(seen);
    });
    for (var i = 0; i < rows.length; i++) details.__pipObserver.observe(rows[i]);
  }

  document.addEventListener(
    'click',
    function (event) {
      var summary = event.target.closest && event.target.closest('.product-info-panel__summary');
      var details = summary && summary.parentNode;
      if (!details || !details.classList.contains('product-info-panel')) return;
      if (details.__pipBusy) return;
      // At capture time details.open still holds the state before the toggle.
      if (details.open) stopDivider(details);
      else startDivider(details);
    },
    true
  );

  var cssReady =
    window.CSS &&
    CSS.supports &&
    CSS.supports('selector(::details-content)') &&
    CSS.supports('interpolate-size: allow-keywords');
  if (cssReady || !('animate' in Element.prototype)) return;

  var DURATION = 250;
  var EASING = 'ease-out';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function finish(details, body, closing) {
    if (closing) details.removeAttribute('open');
    details.removeAttribute('data-closing');
    body.style.overflow = '';
    body.style.boxSizing = '';
    details.__pipBusy = false;
  }

  function run(details, body, closing) {
    var style = window.getComputedStyle(body);
    var full = body.getBoundingClientRect().height;
    var pt = style.paddingTop;
    var pb = style.paddingBottom;
    var shut = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
    var wide = { height: full + 'px', paddingTop: pt, paddingBottom: pb, opacity: 1 };
    details.__pipBusy = true;
    body.style.overflow = 'hidden';
    body.style.boxSizing = 'border-box';
    var anim = body.animate(closing ? [wide, shut] : [shut, wide], {
      duration: DURATION,
      easing: EASING
    });
    var done = function () { finish(details, body, closing); };
    anim.onfinish = done;
    anim.oncancel = done;
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.product-info-panel__summary');
    if (!summary) return;
    var details = summary.parentNode;
    if (!details || !details.classList.contains('product-info-panel')) return;
    var body = details.querySelector('.product-info-panel__body');
    if (!body || reduceMotion.matches) return;
    event.preventDefault();
    if (details.__pipBusy) return;
    if (details.open) {
      details.setAttribute('data-closing', '');
      run(details, body, true);
    } else {
      details.open = true;
      run(details, body, false);
    }
  });
})();
